import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { HelperService } from '../../../core/services/helper/helper.service';
import { GuestService } from '../../../core/services/http/guest/guest.service';
import { ValidationService } from '../../../core/services/validation/validation.service';
import { CustomError } from '../../models/api';

import { MasterDataService } from 'src/app/core/services/http/master-data/master-data.service';
import { UserService } from 'src/app/core/services/user/user.service';

import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  templateUrl: './verify-mobile-number-dialog.component.html',
  styleUrls: ['./verify-mobile-number-dialog.component.scss'],
})
export class VerifyMobileNumberDialogComponent implements OnDestroy {
  abhaAddress!: string;
  abhaNumber!: string;
  countryCode: string = '+91';
  isAbhaVerification: boolean = false;
  isOtpVerification: boolean = false;
  isChangeMobile: boolean = true;
  mobileNumber: number;
  otpValidityStartTime: string;
  requestId: string;
  verifyOtpForm: FormGroup;
  userEntity: string = 'guest';
  userToDoData!: any;

  private destroy$: Subject<void>;

  constructor(
    private formBuilder: FormBuilder,
    private guestService: GuestService,
    private masterService: MasterDataService,
    private userService: UserService,
    private helperService: HelperService,
    private matDialogRef: MatDialogRef<VerifyMobileNumberDialogComponent>,
    private translateService: TranslateService,
    private validationService: ValidationService,
    @Inject(MAT_DIALOG_DATA) private matDialogData: any
  ) {
    this.mobileNumber = this.matDialogData.mobileNumber;
    this.requestId = this.matDialogData.requestId;
    this.otpValidityStartTime = this.matDialogData.otpValidityStartTime;
    this.isChangeMobile = this.matDialogData.isChangeMobile ?? true;
    this.isAbhaVerification = this.matDialogData?.isAbhaVerification ?? false;
    this.isOtpVerification = this.matDialogData?.isOtpVerification ?? false;
    this.abhaNumber = this.matDialogData?.abhaNumber;
    this.abhaAddress = this.matDialogData?.abhaAddress;
    this.countryCode = this.matDialogData.countryCode || '+91';
    this.destroy$ = new Subject<void>();
    this.verifyOtpForm = this.createVerifyOtpForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClickVerify(): void {
    if (this.verifyOtpForm.invalid) {
      return;
    }
    if (this.isAbhaVerification) {
      this.matDialogRef.close({
        otp: this.verifyOtpForm.get(['otp'])?.value,
      });

      return;
    }
    if(this.isOtpVerification){
      this.ToDoOtpVerify();
    }
    else {
      this.otpVerify();
    }
  }

  private createVerifyOtpForm(): FormGroup {
    return this.formBuilder.group({
      otp: [
        null,
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(6),
          Validators.pattern(this.validationService.numberRegex),
        ],
      ],
    });
  }

  private otpVerify(): void {
    this.guestService
      .verifyMobileOtp({
        userEntity: this.userEntity,
        requestId: this.requestId,
        otpValidityStartTime: this.otpValidityStartTime,
        otp: this.verifyOtpForm.get(['otp'])?.value,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: success => {
          // Success
          if (success.data.isOTPVerified) {
            this.helperService.showMessage(this.translateService.instant('toast.success'), success.data.message);
            this.matDialogRef.close(true);
          } else {
            this.helperService.showMessage(this.translateService.instant('toast.error'), success.data.message);
          }
        },
        error: (err: CustomError) => {
          // Error
          this.helperService.showMessage(this.translateService.instant('toast.error'), err.message);
        },
      });
  }

  private ToDoOtpVerify():void {
    this.masterService.verifyToDoOtp(this.verifyOtpForm.get(['otp'])?.value).pipe(takeUntil(this.destroy$))
    .subscribe({
      next: success => {
        // Success
        if (success.data.message === "OTP verified successfully") {
          this.userService.getToDoDetails$().subscribe((res) =>  {
            this.userToDoData = res
          })
          this.userToDoData.isPending = false;
          this.userService.setToDoDetails$(this.userToDoData);
          this.helperService.showMessage(this.translateService.instant('toast.success'), success.data.message);
          this.matDialogRef.close(true);
          // window.location.reload();
        } else {
          this.helperService.showMessage(this.translateService.instant('toast.error'), success.data.message);
        }
      },
      error: (err: CustomError) => {
        // Error
        this.helperService.showMessage(this.translateService.instant('toast.error'), err.message);
      },
    });
  }
}
